var _path, _ellipse, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.722 3.16553H20.2181C21.7365 3.16553 22.9674 4.49444 22.9674 6.13373V18.0065C22.9674 19.6458 21.7365 20.9747 20.2181 20.9747H3.722C2.20358 20.9747 0.972656 19.6458 0.972656 18.0065V6.13373C0.972656 4.49444 2.20358 3.16553 3.722 3.16553Z",
    stroke: "#5F646F",
    strokeWidth: 1.2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.4682,
    cy: 8.88667,
    rx: 2.02583,
    ry: 2.02583,
    stroke: "#5F646F",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.972656 15.8662L6.52291 9.75439L11.6806 16.7463L15.4619 13.5432L21.93 19.2274",
    stroke: "#5F646F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.7c5e15d755c98195bfd8b0601ddbe556.svg";
export { ForwardRef as ReactComponent };